import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useMutation } from '@tanstack/react-query';
import { Link } from "react-router";

import { getBasketData, refetchBasketData, getCustomer, NotificationContext, handleError } from "../router"
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import DonationPrompt from './donation-prompt';
import MembershipPrompt from './membership-prompt';
import BasketEvent from './basket-event';
import AdditionalDonation from './additional-donation';
import BasketSummary from '../components/basket-summary';
import TopPicks from '../components/top-picks';
import LoadingIndicator from '../components/loading-indicator';

export default function Basket() {

    const {notification, setNotification} = useContext(NotificationContext);

    const [groupedEvents, setGroupedEvents] = useState(null);
    const [patchBody, setPatchBody] = useState(null);
    const [hasDonationUpsell, setHasDonationUpsell] = useState(false);
    const [page, setPage] = useState("basket");

    const { data: basketData, isPending: basketDataPending } = getBasketData();
    const { data: customer, isPending: customerPending } = getCustomer();

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;
        
        const grouped_tickets = UTILS.groupTicketsByInstance(basketData.tickets);
        setGroupedEvents(grouped_tickets);

        const has_upsell = UTILS.ticketsHaveDonationUpsell(basketData.tickets);
        setHasDonationUpsell(has_upsell);

    }, [basketData]);

    const patchBasket = useMutation({
        mutationFn: () => QUERIES.patchBasket(patchBody),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    })

    const applyPromoCode = (formData) => {
        const code = formData.get("promocode");
        if (!code) return;
        setPatchBody({ PromoCode : code });
    }

    useEffect(() => {
        if (!patchBody) return;
        patchBasket.mutateAsync();
    }, [patchBody])

    useEffect(() => {
        refetchBasketData();
    }, [])

    if (basketDataPending || customerPending) return <LoadingIndicator type="page" />;

    return (
        <div className="booking-pathway__container booking-pathway__basket">
        <script src="https://webcomponents.spektrix.com/stable/spektrix-component-loader.js" async></script>



            <div className='booking-pathway__main-content'>
                {page == "basket" ?
                    <>
                        <h1 className="booking-pathway__header">Order summary</h1>

                        { !basketDataPending && (!groupedEvents || !groupedEvents.length) &&
                            <p>There are no tickets in your basket.</p>
                        }

                        <div className='basket-items'>
                            {groupedEvents?.map((group) => (
                                <BasketEvent key={group.event_id} event={group} />
                            ))} 
                        </div>

                        <div className='basket-top-picks'>
                            <TopPicks origin="basket" />
                        </div>
                    </>
                :
                page == "additional-donation" ?
                    <AdditionalDonation />
                :null
                }
                
            </div>

            <div className='booking-pathway__summary'>

                {customer?.subscriptions?.length ?
                    /* If user is already a member upsell a donation */
                    <DonationPrompt basketData={basketData} />
                :
                    /* If user is not a member upsell membership */
                    <MembershipPrompt basketData={basketData} />
                }


                <section className='booking-pathway__promo-code'>
                    <form action={applyPromoCode}>
                        <label className='booking-pathway__header' htmlFor="promoInput">Promotion code</label>
                        <div className='booking-pathway__promo-code--input'>
                            <input id="promoInput" type="text" name="promocode" />
                            <input className='btn' type="submit" value="Apply" />
                        </div>
                    </form>
                </section>

                <h2 className='sr-text'>Basket summary</h2>
                <BasketSummary />

            </div>

            
            <div className='booking-pathway__footer'>
                {!basketData ?
                    <p className='btn btn--primary disabled'>Checkout</p>
                : 
                page == "basket" && hasDonationUpsell ?
                    <button type="button" className='btn btn--primary' onClick={() => setPage("additional-donation")}>Continue</button>
                :
                    <Link to="/checkout" className='btn btn--primary'>Checkout</Link>
                }
                <a href="whats-on" className='btn'>Continue browsing</a>
            </div>
        </div>
    );
}